import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import {Session} from '../domain/session';

@Injectable({
  providedIn: 'root'
})
export class RedirectToAdminActivatorGuard  {
  constructor(private session: Session, private router: Router) {
  }

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let query = next.paramMap.get('query');

    if (this.session.isValid()) {
      this.router.navigate(['admin', 'shipment', query]);

      return false;
    }
    return true;
  }
}
